if (!customElements.get('quantity-pricing-tiles')) {
  customElements.define(
    'quantity-pricing-tiles',
    class QuantityPricingTiles extends HTMLElement {
      connectedCallback() {
        this.input = document.getElementById(this.dataset.quantityInput);
        this.tiles = Array.from(this.querySelectorAll('.quantity-pricing-tiles__tile'));

        this.tiles.forEach((tile) => {
          tile.addEventListener('click', () => this.selectTile(tile));
        });

        if (this.input) {
          this.input.addEventListener('change', () => this.syncFromInput());
        }
      }

      selectTile(tile) {
        if (!this.input) return;
        const quantity = tile.dataset.quantity;
        this.input.value = quantity;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
        this.tiles.forEach((t) => t.setAttribute('aria-pressed', String(t === tile)));
      }

      syncFromInput() {
        const value = this.input.value;
        this.tiles.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.quantity === value)));
      }
    }
  );
}
